import { useState } from "react";
import {
  Suggested,
  ReferenceData,
  Prompts,
  AttachFiles,
  LinkReferenceData,
  AgentBuilder,
} from ".";
import { useAuth } from "@/hooks/useAuth";
import { ConfigProvider } from "antd";
import PropTypes from "prop-types";

const AgentBuilderForm = ({
  onFormChange,
  initialData,
  settings,
  onSettingsChange,
  onSave,
  hasChanges,
  introImageSettings,
  onIntroImageChange,
}) => {
  const { userData } = useAuth();

  const [openMenu, setOpenMenu] = useState("");
  const [embedLink, setEmbedLink] = useState("");
  const [copied, setCopied] = useState(false); // trạng thái copy

  const handleMenuToggle = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  const generateEmbedLink = () => {
    if (embedLink) {
      setEmbedLink("");
      setCopied(false);
    } else {
      const uID = userData?.uID;
      const link = `https://sdk.chatme.vn/${uID}`;
      setEmbedLink(link);
      setCopied(false);
    }
  };

  const copyToClipboard = () => {
    if (embedLink) {
      navigator.clipboard.writeText(embedLink).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#50b553",
          colorPrimaryHover: "#50b553",
          colorPrimaryActive: "#50b553",
          colorPrimaryBg: "#50b553",
          colorPrimaryBgHover: "#50b553",
          colorPrimaryBgActive: "#50b553",
          colorPrimaryBorder: "#50b553",
          colorPrimaryBorderHover: "#50b553",
        },
      }}
    >
      <div className="bg-white p-2 sm:p-3 md:p-4 flex flex-col min-h-[calc(100vh-100px)] max-h-[calc(100vh-100px)] border-[#EBEBEB] border-l">
        <div
          className="flex-1 overflow-y-auto"
          style={{
            scrollbarGutter: "stable",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <div className="flex flex-col gap-3">
            <AgentBuilder
              onFormChange={onFormChange}
              initialData={initialData}
              name={initialData?.name}
              introduction={initialData?.introduction}
              greeting={initialData?.greeting}
              settings={settings}
              onSettingsChange={onSettingsChange}
              onSave={onSave}
              hasChanges={hasChanges}
              introImageSettings={introImageSettings}
              onIntroImageChange={onIntroImageChange}
              isOpen={openMenu === "agent-builder"}
              onToggle={() => handleMenuToggle("agent-builder")}
            />
            <Suggested
              isOpen={openMenu === "suggested"}
              onToggle={() => handleMenuToggle("suggested")}
            />
            <ReferenceData
              isOpen={openMenu === "reference-data"}
              onToggle={() => handleMenuToggle("reference-data")}
            />
            <Prompts
              isOpen={openMenu === "prompts"}
              onToggle={() => handleMenuToggle("prompts")}
            />
            <AttachFiles
              isOpen={openMenu === "attach-files"}
              onToggle={() => handleMenuToggle("attach-files")}
            />
            <LinkReferenceData
              isOpen={openMenu === "link-reference-data"}
              onToggle={() => handleMenuToggle("link-reference-data")}
            />
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
};

AgentBuilderForm.propTypes = {
  onFormChange: PropTypes.func.isRequired,
  initialData: PropTypes.object,
  settings: PropTypes.object,
  onSettingsChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  hasChanges: PropTypes.bool,
  introImageSettings: PropTypes.object,
  onIntroImageChange: PropTypes.func.isRequired,
};

export { AgentBuilderForm };